export default {
  roles: state => state.roles
}
